import { z } from 'zod';

export const CircuitDayImportSchema = z.object({
  circuitDayRef: z.union([
    // Trim first: pasting a copied reference often adds a leading/trailing
    // space (e.g. " C0219J02"), which would otherwise fail the regex and keep
    // the "Importer" button disabled.
    z
      .string()
      .trim()
      .regex(/^C\d{4,}J\d{2,}$/, {
        message: "Le format de référence de l'étape est incorrect",
      }),
    z.string().trim().length(0),
  ]), // C0023J01 for example
});

export type CircuitDayImportFormData = z.infer<typeof CircuitDayImportSchema>;
